const state = {
    can_close_modal : true,
    core_const : {},
};

// actions
const actions = {

    LOAD_MAIN_CONST ({commit}) {
        axios.get('/api').then(({data}) => {
            if(data.status === 'operation_success') {
                commit('core_const', data.message);
            }
        }).catch(err => {
            console.log(err);
            commit('core_const', {});
        });
    },

};

// mutations
const mutations = {
    core_const (state, data) {
        state.core_const = {...state.core_const, ...data}
    },
};

export default {
    state,
    actions,
    mutations,
}
